import { LazyQueryExecFunction } from '@apollo/client';
import {
  CompanyDomain,
  CompanyDomainFilterInputObject,
  CompanyDomainsSearchListQuery,
  CompanyDomainsSearchListQueryVariables,
  FilterGroupingEnum,
  SortDirectionEnum,
} from 'graphql-common';
import { DEFAULT_SEARCH_LIST_VARIABLES } from '@lib/enums/urls';
import getLoadOptionsResult from '@lib/utils/getLoadOptionsResult';
import createSearchFilters from '@lib/utils/createSearchFilters';
import { LoadOptionsParams } from '@lib/components/Select/types';

type FetchLazyQuery = LazyQueryExecFunction<CompanyDomainsSearchListQuery, any>;

const searchSchema = [{ fieldName: 'domain' }];

export const fetchSearchList = async (
  searchQuery: string,
  fetchLazyQuery: FetchLazyQuery,
  page: number,
) => {
  const options: { variables: CompanyDomainsSearchListQueryVariables } = {
    variables: {
      ...DEFAULT_SEARCH_LIST_VARIABLES,
      page,
      sorts: { domain: SortDirectionEnum.Asc },
    },
  };
  const filters: CompanyDomainFilterInputObject[] = [];
  if (searchQuery) {
    filters.push(...createSearchFilters(searchQuery, searchSchema));
  }
  options.variables.filters = filters;
  const { data } = await fetchLazyQuery(options);
  return getLoadOptionsResult(
    data,
    (dataItem: CompanyDomain) => ({
      value: dataItem.id,
      label: dataItem.domain,
      data: dataItem,
    }),
    searchQuery,
  );
};

export const getCompanyDomainsLoadOptions =
  (fetchLazyQuery: FetchLazyQuery) =>
  (searchQuery: string, loadedOptions: unknown, params: LoadOptionsParams) =>
    fetchSearchList(searchQuery, fetchLazyQuery, params?.page || 1);
